const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'avif'];
const videoExtensions = ['mp4', 'webm', 'ogg', 'ogv', 'mov', 'm4v'];
const audioExtensions = ['mp3', 'wav', 'ogg', 'oga', 'aac', 'm4a', 'flac'];
const pdfExtensions = ['pdf'];

export const getFileExtension = value => {
  if (!value || typeof value !== 'string') return '';

  const filename = value
    .split('#')[0]
    .split('?')[0]
    .split('/')
    .pop();
  const parts = filename?.split('.') || [];

  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

const hasExtension = (value, extensions) => {
  return extensions.includes(getFileExtension(value));
};

const getFiletype = file => {
  return (
    file?.filetype ||
    file?.mime_type ||
    file?.mimetype ||
    file?.type ||
    ''
  ).toLowerCase();
};

export const getMediaKind = file => {
  const filetype = getFiletype(file);
  const originalName = file?.original_name || file?.name || '';
  const filename = file?.filename || '';

  if (
    filetype.includes('image') ||
    hasExtension(originalName, imageExtensions) ||
    hasExtension(filename, imageExtensions)
  ) {
    return 'image';
  }

  if (
    filetype.includes('video') ||
    hasExtension(originalName, videoExtensions) ||
    hasExtension(filename, videoExtensions)
  ) {
    return 'video';
  }

  if (
    filetype.includes('audio') ||
    hasExtension(originalName, audioExtensions) ||
    hasExtension(filename, audioExtensions)
  ) {
    return 'audio';
  }

  if (
    filetype.includes('pdf') ||
    hasExtension(originalName, pdfExtensions) ||
    hasExtension(filename, pdfExtensions)
  ) {
    return 'pdf';
  }

  return 'unknown';
};

export const getMediaSource = (src, kind) => {
  if (!src || typeof src !== 'string') return src;

  if (kind === 'video' && !src.includes('#')) {
    return `${src}#t=0.1`;
  }

  return src;
};

export const getMediaPreview = file => {
  const fileKind = getMediaKind(file);
  const thumbnailUrl = file?.thumbnails?.[0]?.filename;

  if (thumbnailUrl) {
    return {
      kind: 'image',
      fileKind,
      source: 'thumbnail',
      src: thumbnailUrl
    };
  }

  if (file?.filename) {
    return {
      kind: fileKind,
      fileKind,
      source: 'file',
      src: file.filename
    };
  }

  return null;
};
